<template>
  <div class='event-creator'>
    <v-container>
      <v-col>
        <v-row>EVENT NAME: <v-text-field v-model='eventName' /></v-row>
        <v-row>TYPE: <v-select v-model='type' :items='SESSION_TYPES' autocomplete required></v-select></v-row>
        <v-row>EVENT SIZE: <v-text-field v-model='eventSize' type='number' /></v-row>
        <v-row>EVENT NUM: <v-text-field v-model='eventNum' type='number' /></v-row>
        <v-row>SEASON ID: <v-text-field v-model='seasonID' type='number' /></v-row>
        <v-row>SEGMENT ID: <v-text-field v-model='segmentID' type='number' /></v-row>
        <v-row><v-btn color='primary' @click='createEvent'>SUBMIT</v-btn></v-row>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'

export default {
  name: 'event-creator',
  data () {
    return {
      eventNum: 0,
      eventName: '',
      type: '3x3',
      seasonID: 1,
      segmentID: 1,
      eventSize: 64,

      SESSION_TYPES: ['3x3', '2x2', '4x4', '5x5', '6x6', '7x7', '3x3OH', '3BLD', 'Clock', 'Megaminx', 'Pyraminx', 'Skewb', 'Square-1', 'FTO'],
    }
  },
  methods: {
    async createEvent () {
      let confirmation = confirm(`Creating new event. Confirm?`)
      if (!confirmation) return
      let eventID = `s${this.seasonID.toString().padStart(2, '0')}s${this.segmentID}e${this.eventNum}`
      let {data} = await AdminService.createEvent({
        eventID,
        eventName: this.eventName,
        eventSize: this.eventSize,
        type: this.type,
        seasonID: this.seasonID,
        segmentID: this.segmentID,
      })
      if (data.error) {
        return alert(`Error: ${data.error} - ${data.message}`)
      }
      if (data.success) {
        return alert('Success!')
      }
      alert(`Something went wrong and I don't know what: result - ${data}`)
    }
  },
}
</script>
